import React from "react";

import {
  Card,
  CardBody,
  CardTitle,
  Content,
  Stack,
  StackItem
} from "@patternfly/react-core";

const ProjectSection = ({
  title = null,
  description = null,
  isCard = true,
  isGlass = true,
  children
}) => {
  const content = (
    <Stack hasGutter>
      {description && (
        <StackItem>
          <Content>
            <p>
              {description}
            </p>
          </Content>
        </StackItem>
      )}

      {children && (
        <StackItem>
          {children}
        </StackItem>
      )}
    </Stack>
  );

  if (isCard) {
    return (
      <Card isGlass={isGlass}>
        {title && (
          <CardTitle>
            {title}
          </CardTitle>
        )}

        <CardBody>
          {content}
        </CardBody>
      </Card>
    );
  }

  return (
    <Stack hasGutter>
      {title && (
        <StackItem>
          <Content>
            <h2>
              {title}
            </h2>
          </Content>
        </StackItem>
      )}

      <StackItem>
        {content}
      </StackItem>
    </Stack>
  );
};

export default ProjectSection;